import { Chatroom } from './chatroom';
export class SendTask {
  chatroom_list: Array<Chatroom>;
  client_list: Array<any>;
  message_list: Array<Message>;
  task_covering_chatroom_count: number;
  task_covering_people_count: number;
  task_sended_failed_count: number;
  task_sended_count: number;
  task_create_time: number;
  batch_send_task_id: string;
  send_time: number;
  send_time_real: number;
  announcement?: number;
  chatroom_count: number;

  status: number;

  keywords_id: string;
  keyword_list: Array<any>;

  constructor(sendTask: any = {}) {
    this.status = sendTask.status;
    this.batch_send_task_id = sendTask.batch_send_task_id || null;
    this.task_covering_chatroom_count = sendTask.task_covering_chatroom_count;
    this.task_covering_people_count = sendTask.task_covering_people_count;
    this.task_sended_failed_count = sendTask.task_sended_failed_count;
    this.task_sended_count = sendTask.task_sended_count;
    this.task_create_time = sendTask.task_create_time;
    this.announcement = sendTask.announcement || 0;
    this.chatroom_count = sendTask.chatroom_count || 0;

    this.send_time = sendTask.send_time || 0;

    this.chatroom_list = sendTask.chatroom_list
      ? sendTask.chatroom_list.map(item => new Chatroom(item))
      : [];
    this.client_list = sendTask.client_list
      ? sendTask.client_list.map(item => new Chatroom(item))
      : [];
    this.message_list = sendTask.message_list
      ? sendTask.message_list.map(item => new Message(item))
      : [];

    sendTask.keywords_id && (this.keywords_id = sendTask.keywords_id);
    sendTask.keyword_list && (this.keyword_list = sendTask.keyword_list);
  }
}

export class Message {
  // material_id:number;
  real_type: number;
  text: string;
  source_url: string;
  thumb_url: string;
  title: string;
  desc: string;
  size: number;
  duration: number;
  msg_id: string;
  real_content: string;
  msg_local_id: string;
  msg_svr_id: string;
  talker: string;
  create_time: string;
  content:string;
  // 1为群发消息；2为自动回复；3为回复签到；4为入群回复
  // task_type = db.Column(db.Integer, index=True, nullable=False)

  // 发送内容的类型；1为文字；2为公众号；3为链接；4为文件；5为小程序
  // task_send_type = db.Column(db.Integer, index=True, nullable=False)

  constructor(material: any = {}) {
    // this.material_id = material.material_id || null;
    this.real_type = material.real_type || 1;
    this.text = material.text || '';
    this.source_url = material.source_url;
    this.thumb_url = material.thumb_url;
    this.title = material.title;
    this.desc = material.desc;
    this.size = material.size;
    this.duration = material.duration;
    this.msg_id = material.msg_id;
    this.real_content = material.real_content;
    this.msg_local_id = material.msg_local_id;
    this.msg_svr_id = material.msg_svr_id;
    this.talker = material.talker;
    this.create_time = material.create_time;
    this.content = material.content || '';
  }
}

export class PullEvent {
  event_id: string; //必填

  need_fission: boolean;
  need_condition_word: boolean;
  need_pull_people: boolean;
  fission_word_1: string;
  fission_word_2: string;
  condition_word: string;
  pull_people_word: string;
  event_title: string;
  start_time: number; //秒
  end_time: number; //秒
  chatroom_name_protect: boolean;
  poster_raw: string;
  start_name: string;
  start_index: number;
  chatroom_repeat_protect: boolean;

  constructor(event: any = {}) {
    this.event_id = event.event_id;
    this.need_fission = event.need_fission;
    this.need_condition_word = event.need_condition_word;
    this.need_pull_people = event.need_pull_people;
    this.fission_word_1 = event.fission_word_1;
    this.fission_word_2 = event.fission_word_2;
    this.pull_people_word = event.pull_people_word;
    this.event_title = event.event_title;
    this.start_time = event.start_time;
    this.poster_raw = event.poster_raw;
    this.start_name = event.start_name;
    this.start_index = event.start_index;
    this.chatroom_repeat_protect = event.chatroom_repeat_protect;
  }

  get start_time_string() {
    return this.start_time * 1000;
  }
  get end_time_string() {
    return this.end_time * 1000;
  }
}



// WEBPACK FOOTER //
// ./src/class/task.ts